import { useEffect, useState } from "react";

/** false during SSR and the hydration render, true after mount: gate browser-only UI on it. */
export function useMounted(): boolean {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted;
}
